/* ==========================================================================
   OLIVER KRAUS — Hemp study behaviour (journey, composition, image reveal).
   Registers with the module system in ok-theme.js. Loaded site-wide from
   snippets/ok-brand-head.liquid so sections added in the theme editor work.
   ========================================================================== */
(function () {
  'use strict';
  function start() {
    var OK = window.OK;
    if (!OK || !OK.define) return;
    var $ = OK.$, $$ = OK.$$, Bag = OK.Bag;

    /* ---------- plant → body journey ---------- */
    OK.define('journey', function (el) {
      var bag = new Bag();
      var items = $$('[data-ok-journey-item]', el);
      if (!items.length) return {};
      var count = $('[data-ok-journey-count]', el);
      var progress = $('[data-ok-journey-progress]', el);
      var photos = $$('[data-ok-journey-photo]', el);
      var cur = -1, raf = 0, seen = false;
      function set(i) {
        if (i === cur) return;
        cur = i;
        var art = items[i].getAttribute('data-art') || 'plant';
        var hasPhoto = false;
        photos.forEach(function (p) {
          var on = Number(p.getAttribute('data-ok-journey-photo')) === i;
          p.classList.toggle('is-on', on);
          if (on) hasPhoto = true;
        });
        el.setAttribute('data-art', hasPhoto ? 'photo' : art);
        el.setAttribute('data-stage', i);
        items.forEach(function (it, j) {
          it.classList.toggle('is-active', j === i);
          it.classList.toggle('is-done', j <= i);
        });
        if (count) count.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        if (progress) el.style.setProperty('--ok-progress', Math.round(((i + 1) / items.length) * 100) + '%');
      }
      // The stage whose centre is nearest the trigger line wins, and must beat
      // the current stage by a dead zone so trackpad jitter cannot flip it.
      function track() {
        raf = 0;
        var vh = window.innerHeight;
        var r = el.getBoundingClientRect();
        if (!seen && r.top < vh * 0.9) { seen = true; el.classList.add('is-seen'); }
        if (r.bottom < -vh * 0.3 || r.top > vh * 1.3) return;
        var line = vh * 0.52, best = cur < 0 ? 0 : cur, bestD = Infinity, curD = Infinity;
        for (var i = 0; i < items.length; i++) {
          var b = items[i].getBoundingClientRect();
          var d = Math.abs(b.top + b.height / 2 - line);
          if (i === cur) curD = d;
          if (d < bestD) { bestD = d; best = i; }
        }
        if (cur < 0 || (best !== cur && bestD < curD - 26)) set(best);
      }
      function onScroll() { if (!raf) raf = requestAnimationFrame(track); }
      bag.on(window, 'scroll', onScroll, { passive: true });
      bag.on(window, 'resize', onScroll, { passive: true });
      set(0);
      track();
      var t = setTimeout(track, 300);
      return {
        destroy: function () { cancelAnimationFrame(raf); clearTimeout(t); bag.clear(); },
        blockSelect: function (block) { var i = items.indexOf(block); if (i > -1) set(i); seen = true; el.classList.add('is-seen'); },
        select: function () { seen = true; el.classList.add('is-seen'); }
      };
    });

    /* ---------- composition threads: entrance, count-up, fibre focus ---------- */
    OK.define('composition', function (el) {
      var bag = new Bag();
      var nums = $$('[data-ok-count-to]', el);
      var raf = 0, io = null;
      function countUp() {
        if (OK.reduce()) return;
        var t0 = 0;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / 1100);
          var e = 1 - Math.pow(1 - k, 3);
          nums.forEach(function (n) { n.textContent = Math.round(Number(n.getAttribute('data-ok-count-to')) * e) + '%'; });
          if (k < 1) raf = requestAnimationFrame(step);
        }
        raf = requestAnimationFrame(step);
      }
      function enter() { if (el.classList.contains('is-in')) return; el.classList.add('is-in'); countUp(); if (io) io.disconnect(); }
      if (OK.reduce() || !('IntersectionObserver' in window)) enter();
      else {
        io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) enter(); }); }, { threshold: 0.2 });
        io.observe(el);
      }
      /* hover/focus previews a fibre; click/tap/Enter pins it (aria-pressed reflects the pin only) */
      var picks = $$('[data-ok-pick]', el), pinned = null, hover = null;
      function paint() {
        var g = hover || pinned;
        if (g) el.setAttribute('data-active', g); else el.removeAttribute('data-active');
        picks.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ok-pick') === pinned ? 'true' : 'false'); });
      }
      picks.forEach(function (btn) {
        var g = btn.getAttribute('data-ok-pick');
        bag.on(btn, 'mouseenter', function () { hover = g; paint(); });
        bag.on(btn, 'mouseleave', function () { if (hover === g) hover = null; paint(); });
        bag.on(btn, 'click', function () { pinned = pinned === g ? null : g; hover = null; paint(); });
      });
      return { destroy: function () { cancelAnimationFrame(raf); if (io) io.disconnect(); bag.clear(); }, select: enter };
    });

    /* ---------- image reveal slider ---------- */
    OK.define('compare', function (el) {
      var bag = new Bag();
      var range = $('[data-ok-compare-range]', el);
      function mode() { el.classList.toggle('is-static', OK.reduce()); }
      function apply() { if (range) el.style.setProperty('--pos', range.value + '%'); }
      if (range) { bag.on(range, 'input', apply); bag.on(range, 'change', apply); }
      bag.on(window.matchMedia('(prefers-reduced-motion: reduce)'), 'change', mode);
      mode(); apply();
      return { destroy: function () { bag.clear(); } };
    });
  }
  if (window.OK && window.OK.define) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
